import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFedex } from '@fortawesome/free-brands-svg-icons';

@Component({
    selector: 'app-form-shipping-select',
    imports: [CurrencyPipe, FontAwesomeModule],
    templateUrl: './form-shipping-select.component.html',
    styleUrl: './form-shipping-select.component.scss',
    standalone: true
})
export class FormShippingSelectComponent {
  @Input() listRate;
  @Output() rateSelected = new EventEmitter<any>();
  iconFedex = faFedex;

  selectRate(value: any) {

    let rate: any = {};
    if (Number.isInteger(value)) {

      Object.assign(rate, { totalPrice: 0, carrier: 'drop_store', carrierId: 3 });
    } else {
      rate = this.listRate.data.find((f: any) => f.service === value);
    }

    const preShippingCost = +rate.totalPrice * 1.05;

    this.rateSelected.emit(rate);
    return true;

  }

}
